import { render, staticRenderFns } from "./FaqTemplate.vue?vue&type=template&id=2dba9e9b&scoped=true"
import script from "./FaqTemplate.vue?vue&type=script&lang=js"
export * from "./FaqTemplate.vue?vue&type=script&lang=js"
import style0 from "./FaqTemplate.vue?vue&type=style&index=0&id=2dba9e9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dba9e9b",
  null
  
)

export default component.exports